// eslint-disable-next-line import/no-extraneous-dependencies
import { combineReducers } from "redux";
import { fetchReducer, formReducer } from "./institution/institutionAffiliationReducer";
import selectedInstitutionReducer from "./institution/selectedInstitutionReducer";

import institutionAddressesReducer from "./institution/institutionAddressesReducer";
import institutionContactsReducer from "./institution/institutionContactsReducer";

import { affilationDetailReducer, institutionJobIdReducer } from "./institution/InstitutionAffiliationDetailsReducer";
import institutionAffilaiationSummaryReducer from "./institution/institutionAffiliationSummaryReducer";
import institutionAssociatedProviderReducer from "./institution/institutionAssociatedProvidersReducer";
import institutionCredentialsReducer from "./institution/institutionCredentialsReducer";
import institutionSiteRestrictionsReducer from "./institution/institutionSiteRestrictionsReducer";
import insititutionStatusListReducer from "./institution/institutionStatusListReducer";
import { packageReducer, treeReducer } from "./institution/institutionTreeReducer";
import selectedInstitutionProviderReducer from "./institution/selectedInstitutionProviderReducer";
import lmsTrainingReducer from "./person/lmsTrainingReducer";
import myTaskReducer from "./person/myTaskReducer";
import personAddressesReducer from "./person/personAddressesReducers";
import personAffiliationsReducer from "./person/personAffiliationsReducer";
import personContactsReducer from "./person/personContactsReducer";
import personDataReducer from "./person/personDataReducer";
import personSummaryReducer from "./person/personSummaryReducer";
import selectedMemberRoleStatusReducer from "./person/selectedMemberRoleStatusReducer";
import selectedMemberRosterStatusReducer from "./person/selectedMemberRosterStatusReducer";
import updateUserGroupReducer from "./person/updateUserGroupReducer";

import { apiSlice } from "stores/apis/apiSlice";
import listOfValuesReducer from "../slice/ListOfValues";
import personDetailReducer from "../slice/personDeatils";
import rumsReducer from "../slice/rums";

import approvalMappingsReducer from "../slice/approvalMappings";
import attributeSetupReducer from "../slice/attributeSetup";
import fwaReducer from "../slice/fwa";
import grantsPackageReducer from "../slice/grantsPackage";
import manageCommitteeReducer from "../slice/manageCommitte";
import personRoleSetupReducer from "../slice/personRoleSetup";
import unregisteredInstReducer from '../slice/unregisteredInstitution';
import providerReducer from "../slice/provider";
import selectedCredRow from "./credentialing/selectCredRow";
import institutionAttributesReducer from "./institution/institutionAttributesReducer";
import personRequiredAttributesReducer from "./person/personRequiredAttributesReducer";
import { personRosterRoleReducer, selectedReducer } from "./person/personRosterRoleReducer";

export const EmptyReducer = (state = null) => state;

export default combineReducers({
  institutionAffiliation: fetchReducer,
  institutionAffiliationform: formReducer,
  institutionAddressesData: institutionAddressesReducer,
  institutionContactsData: institutionContactsReducer,
  institutionProviders: providerReducer,
  institutionSiteRestrictionsData: institutionSiteRestrictionsReducer,
  institutionCredentialsData: institutionCredentialsReducer,
  institutionAssociatedProviderData: institutionAssociatedProviderReducer,
  insititutionStatusList: insititutionStatusListReducer,
  InstitutionAffiliationDetails: affilationDetailReducer,
  institutionJobId: institutionJobIdReducer,
  institutionTree: treeReducer,
  packageTree: packageReducer,
  personRosterRole: personRosterRoleReducer,
  institutionAttributes: institutionAttributesReducer,
  institutionAffilaiationSummary: institutionAffilaiationSummaryReducer,
  selectedInstitution: selectedInstitutionReducer,
  selectedInstitutionProvider: selectedInstitutionProviderReducer,

  myTasks: myTaskReducer,
  personAffiliations: personAffiliationsReducer,
  personSummary: personSummaryReducer,
  personDetails: personDetailReducer,
  personAddressesData: personAddressesReducer,
  personContactsData: personContactsReducer,
  personData: personDataReducer,
  updatedUserGroup: updateUserGroupReducer,
  lmsTrainingData: lmsTrainingReducer,
  selectedMemberRoleStatus: selectedMemberRoleStatusReducer,
  selectedMemberRosterStatus: selectedMemberRosterStatusReducer,
  personAttributes: personRequiredAttributesReducer,
  selectedRosterRole: selectedReducer,
  listOfValues: listOfValuesReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
  selectedCredRow,
  rums: rumsReducer,
  approvalMappings: approvalMappingsReducer,
  personRoleSetup: personRoleSetupReducer,
  attributeSetup: attributeSetupReducer,
  manageCommittee: manageCommitteeReducer,
  grantsPackage: grantsPackageReducer,
  fwa: fwaReducer,
  unregisteredInst: unregisteredInstReducer,
});
